import { useRef } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-Calendar-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
const initialState = {
  selectedDate: null,
  selectedText: ''
};
const useSelectedAriaDescribedby = () => {
  const localize = useTextLocalizer();
  const state = useRef(initialState);
  const getSelectedText = (day, property) => {
    const selectedText = localize(property, {
      date: day.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    });
    return selectedText;
  };
  const handleAriaDateSelection = (day, isSelected) => {
    const selectedText = isSelected ? getSelectedText(day, 'notselected.date.aria') : getSelectedText(day, 'select.date.aria');
    state.current = {
      selectedDate: day,
      selectedText
    };
  };
  const resetAllAriaSelected = () => {
    state.current = initialState;
  };
  return {
    ariaSelectedDate: state.current.selectedDate,
    ariaSelectedText: state.current.selectedText,
    resetAllAriaSelected,
    handleAriaDateSelection
  };
};
export default useSelectedAriaDescribedby;
//# sourceMappingURL=useSelectedAriaDescribedby.js.map